import { latLngToXY } from "../../utils/helpers/getIntersectionPoint";

export const pinSvg = `data:image/svg+xml,%3Csvg%20height%3D%22200px%22%20width%3D%22200px%22%20version%3D%221.1%22%20id%3D%22Capa_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20viewBox%3D%220%200%20401.296%20401.296%22%20xml%3Aspace%3D%22preserve%22%20fill%3D%22%23000000%22%3E%3Cg%20id%3D%22SVGRepo_bgCarrier%22%20stroke-width%3D%220%22%3E%3C%2Fg%3E%3Cg%20id%3D%22SVGRepo_tracerCarrier%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fg%3E%3Cg%20id%3D%22SVGRepo_iconCarrier%22%3E%3Cg%3E%3Cg%3E%3Cpath%20style%3D%22fill%3A%23bb0000%3B%22%20d%3D%22M200.636%2C401.296c-9.535%2C0-17.286-7.757-17.286-17.286v-98.197H44.99v-17.286%20c0-27.287%2C22.937-51.267%2C63.082-66.143l17.465-140.4C81.997%2C50.217%2C72.659%2C31.32%2C72.659%2C17.286V0h255.973v17.286%20c0%2C14.04-9.332%2C32.937-52.878%2C44.698l17.465%2C140.412c40.151%2C14.869%2C63.088%2C38.838%2C63.088%2C66.131v17.286H217.928v98.197%20C217.928%2C393.539%2C210.171%2C401.296%2C200.636%2C401.296z%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E`;

export const calculateDistance = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
) => {
  const R = 6371e3;
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

/**
 * Returns the bearing in degrees [0..360), with 0° = North, from p1 to p2.
 */
export function getMapBearing(
  p1: { lat: number; lng: number },
  p2: { lat: number; lng: number },
  centerLat: number,
  centerLng: number
) {
  const p1XY = latLngToXY(p1.lat, p1.lng, centerLat, centerLng);
  const p2XY = latLngToXY(p2.lat, p2.lng, centerLat, centerLng);
  const degree = getAngleOnSitePlan(p1XY, p2XY);
  console.log("P1XY, P@XY", degree);
  const lat1 = (p1.lat * Math.PI) / 180;
  const lat2 = (p2.lat * Math.PI) / 180;
  const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;

  const y = Math.sin(dLon) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  let bearingDeg = (Math.atan2(y, x) * 180) / Math.PI;
  return (bearingDeg + 360) % 360;
}

/**
 * Computes the angle on the site plan so that 0° = "up" (top).
 * By default, atan2(dy, dx) would have 0° = "right". We shift to make 0° = up.
 */
export function getAngleOnSitePlan(
  p1: { x: number; y: number },
  p2: { x: number; y: number }
) {
  console.log("Numbers", p1, p2);
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  console.log("DXDY", dx, dy);
  // const rawDeg = (Math.atan2(dy, dx) * 180) / Math.PI; // 0°=right, 90°=down
  // let siteDeg = 90 - rawDeg; // shift so 0°=up
  // siteDeg = (siteDeg + 360) % 360; // normalize to [0..360)
  // return siteDeg;
  // Flip dy so that upward (which is negative in image coordinates) becomes positive.
  let angle = Math.atan2(-dy, dx) * (180 / Math.PI);
  if (angle < 0) angle += 360;
  return angle;
}

export const anglePairs: Array<[number, number]> = [
  [22.5, 247.5],
  [45.1, 225],
  [67.5, 202.5],
  [112.5, 337.5],
  [135, 315],
  [157.5, 292.5],
];

export const BOUNDARY_ANGLES = [
  22.5, 45.1, 67.5, 112.5, 135, 157.5, 202.5, 225, 247.5, 292.5, 315, 337.5,
];

// Euclidean distance for Cartesian coordinates (x, y)
export function calculateXYDistance(
  x1: number | undefined,
  y1: number | undefined,
  x2: number | undefined,
  y2: number | undefined
): number {
  const safeX1 = x1 ?? 0;
  const safeY1 = y1 ?? 0;
  const safeX2 = x2 ?? 0;
  const safeY2 = y2 ?? 0;
  const dx = safeX1 - safeX2;
  const dy = safeY1 - safeY2;
  return Math.sqrt(dx * dx + dy * dy);
}

export function calculateLatLngDistance(
  lat1: number | undefined,
  lng1: number | undefined,
  lat2: number | undefined,
  lng2: number | undefined
): number {
  if (
    lat1 === undefined ||
    lng1 === undefined ||
    lat2 === undefined ||
    lng2 === undefined
  ) {
    throw new Error("All latitude and longitude values must be defined.");
  }

  // Earth's radius in meters
  const R = 6371e3;
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

  const φ1 = toRadians(lat1);
  const φ2 = toRadians(lat2);
  const Δφ = toRadians(lat2 - lat1);
  const Δλ = toRadians(lng2 - lng1);

  const a =
    Math.sin(Δφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

export function calculatDistance(
  x1: number | undefined,
  y1: number | undefined,
  x2: number | undefined,
  y2: number | undefined,
  lat1?: number,
  lng1?: number,
  lat2?: number,
  lng2?: number
): number {
  if (
    lat1 !== undefined &&
    lng1 !== undefined &&
    lat2 !== undefined &&
    lng2 !== undefined
  ) {
    return calculateLatLngDistance(lat1, lng1, lat2, lng2);
  }
  return calculateXYDistance(x1, y1, x2, y2);
}
